import generalUpload from "../_section/upload.class";

export class userDDBankAccountUpload extends generalUpload {
    constructor(request, upload, queries) {
        super(request, upload, queries);
    }
}

const template = {
    items: [
        {
            name: 'documentDate',
            label: 'Document Date',
            type: 'date',
        },
        // {
        //     name: 'iban',
        //     label: 'IBAN',
        //     type: 'text',
        // },
        // {
        //     name: 'bic',
        //     label: 'BIC',
        //     type: 'text',
        // },
        // {
        //     name: 'accountName',
        //     label: 'Name on Account',
        //     type: 'text',
        // },
        // {
        //     name: 'address',
        //     label: 'Address on Account',
        //     type: 'textarea',
        // },
        // {
        //     name: 'postCode',
        //     label: 'Post Code',
        //     type: 'text',
        // },
        // {
        //     name: 'country',
        //     label: 'Country',
        //     type: 'text',
        // },
    ]
}

export class adminDDBankAccountUpload extends userDDBankAccountUpload {

    constructor(request, upload, queries) {
        super(request, upload, queries);
        this.calcValues(template)
        if (this.values.documentDate) {
            this.setDateData({
                dated: this.values.documentDate,
                expires: this.values.documentDate.add(1, 'year'),
            })
        }
    }


}
